module.exports = __webpack_public_path__ + "static/media/img83.e165b52d.jpg";